import isEqual from 'lodash/isEqual';
import { useSelector } from 'react-redux';

import { EnterpriseStatus } from 'types/models/enterprise';

import {
  selectCurrentEnterprise,
  selectCurrentEnterpriseConfig,
  selectCurrentEnterpriseCountry,
  selectCurrentEnterpriseId,
  selectCurrentEnterpriseName,
  selectCurrentEnterpriseStatus
} from './selectors';

export function useEnterprise() {
  return useSelector(selectCurrentEnterprise, isEqual);
}

export function useEnterpriseId() {
  return useSelector(selectCurrentEnterpriseId, isEqual);
}

export function useEnterpriseName() {
  return useSelector(selectCurrentEnterpriseName, isEqual);
}

export function useEnterpriseCountry() {
  return useSelector(selectCurrentEnterpriseCountry);
}

export function useEnterpriseConfig() {
  return useSelector(selectCurrentEnterpriseConfig, isEqual);
}

export function useIsUSEnterprise() {
  return useSelector(selectCurrentEnterpriseCountry) === 'USA';
}

export function useIsEnterpriseDisabledOrDuplicate() {
  const status = useSelector(selectCurrentEnterpriseStatus);
  return status && [EnterpriseStatus.DISABLED, EnterpriseStatus.DUPLICATE].includes(status);
}
